import Result from '@package/services/src/Result';

import { PaymentMethodsService } from './services';
import { GetPaymentMethodsRequest, PaymentMethods } from './types';

export default class PaymentMethodsInteractor {
  public constructor(private readonly paymentMethodsService: PaymentMethodsService) {}

  public getPaymentMethods(request?: GetPaymentMethodsRequest): Promise<Result<Array<PaymentMethods>>> {

    return this.paymentMethodsService.getPaymentMethods(request);
  }

  public getShoppingCartPaymentMethods(request?: GetPaymentMethodsRequest): Promise<Result<Array<PaymentMethods>>> {
    return this.paymentMethodsService.getShoppingCartPaymentMethods(request);
  }
}
